import { createArray } from 'helpers';
import PF from 'pathfinding';
import Entity from '../Entity';
import Nature from '../Nature/Nature';

export default class Danger extends Entity {

    colony: Nature;
    props: EntityBaseProps & DangerProps;
    setup: EntityBaseSetup & DangerSetup;

    constructor(gameState: GameState, type: DangerType, setup: EntityBaseSetup & DangerSetup, props?: EntityBaseProps & DangerProps, state?: any) {
        // Get props
        props = {
            idleTexture: `danger/${type}/danger-${type}.png`,
            movingTextures: createArray(12, i => `danger/${type}/danger-${type}-moving-${i + 1}.png`),
            ...props,
        };
        
        // Call super
        super(gameState, 'danger', type, setup, props, state);

        // Initialize
        this.props = props;
        this.setup = setup;
        this.colony = gameState.entities.natures.active.find(nature => nature.type === 'dangerColony') as Nature;
        this.zIndex = 5;
    }

    getPathGrid = () => {
        const grid = new PF.Grid(this.gameState.gridMatrix);

        // Add bridge blockers to grid to prevent from crossing the river if paradise is unlocked
        if (this.gameState.unlocks.paradise) {
            this.gameState.entities.natures.active.forEach(nature => {
                if (nature.type === 'bridgeBlocker') {
                    grid.setWalkableAt(nature.cell.x, nature.cell.y, false);
                }
            });
        }
        
        return grid;
    }

}